module.exports = __webpack_public_path__ + "static/media/fiori-reali.e0e1c45e.png";